<template>
  <div>
    <HomePageToolbar></HomePageToolbar>
    <div class="pa-4 pa-md-12" style="position:relative">
      <v-img
        :src="vieja_tiuque"
        height="200"
        width="400"
        contain
        style="position: absolute; top: 320px; left: -130px; filter: opacity(20%); transform: scaleX(-1)"
      ></v-img>

      <v-row no-gutters>
        <v-col cols="12" lg="3">
          <p class="display-1 primary--text font-weight-bold mb-8">
            Sobre el proyecto
          </p>

          <v-card flat color="transparent" class="pr-3" max-width="500">
            <p class="secondary--text font-weight-bold title">
              Somos una plataforma colaborativa que invita a participar a buzos
              deportivos, pescadores y ciudadanía en el levantamiento de
              información sobre la distribución y abundancia de peces de roca,
              fauna y flora marina bentónica de las costas de Chile.
            </p>
          </v-card>
        </v-col>
        <v-col cols="12" lg="8" class="mx-auto">
          <v-row no-gutters>
            <v-col cols="12" sm="4" class="d-none d-sm-flex">
              <v-img :src="cabrillaImage" height="100%"></v-img>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card
                class="primary pa-6 pa-md-10 d-flex flex-column justify-center"
                dark
                tile
                flat
                height="100%"
              >
                <p class="title font-weight-bold">Te invitamos a</p>
                <p>
                  <span class="number-has-rounded-border">1</span>
                </p>
                <p class="body-1">
                  Compartir tus experiencias y avistamientos realizados.
                </p>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4" class="d-none d-sm-flex">
              <v-img :src="vieja_tiuqueImage" height="100%"></v-img>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4">
              <v-card
                class="secondary pa-6 pa-md-10 d-flex flex-column justify-center"
                dark
                tile
                flat
                height="100%"
              >
                <p>
                  <span class="number-has-rounded-border">2</span>
                </p>
                <p class="body-1">
                  Descubrir información de las especies que habitan el fondo
                  marino, las costas, e islas oceánicas de Chile.
                </p>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4" class="d-none d-sm-flex">
              <v-img :src="IMG_2722" height="100%"></v-img>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card
                class="pa-6 pa-md-10 d-flex flex-column justify-center"
                color="#004f68"
                dark
                tile
                flat
                height="100%"
              >
                <p>
                  <span class="number-has-rounded-border">3</span>
                </p>
                <p class="body-1">
                  Revisar reportes interactivos de biodiversidad en distintas
                  zonas de nuestro país.
                </p>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <HomePageRecentOccurrence></HomePageRecentOccurrence>
    </div>

    <v-img :src="IMG_5335" height="200" full-width></v-img>
  </div>
</template>

<script>
import HomePageRecentOccurrence from "./HomePageRecentOccurrence";
import HomePageEvent from "./HomePageEvent";
import HomePageToolbar from "./HomePageToolbar";
export default {
  data: () => ({
    cabrillaImage: require("@/assets/home/cabrilla.jpg"),
    vieja_tiuqueImage: require("@/assets/home/vieja_tiuque.jpg"),
    vieja_tiuque: require("@/assets/home/15_Vieja tiuque. Borde mejorado (A.pictus).png"),
    IMG_2722: require("@/assets/home/IMG_2722.jpg"),
    IMG_5335: require("@/assets/IMG_5335.jpg")
  }),
  components: {
    HomePageRecentOccurrence,
    HomePageEvent,
    HomePageToolbar
  }
};
</script>
<style>
.number-has-rounded-border {
  border: 1px solid #ffffff;
  border-radius: 50%;
  padding: 4px 9px;
}
</style>
